export const SPARE_PART_REQUEST_DOMAIN_KEY = 'sparePartRequests';
